import React from 'react'
import '../flash_deals/FlashDeals.css'
import { Col, Container, Row } from 'react-bootstrap'

const FlashDeals = () => {
  return (
    <>
        <section id="flash_deals">
            <Container>
                <Row>
                    <Col lg={6}>
                        <div class="flash_manu">
                            <h1 class="title">Flash Deals Of The Week</h1>
                            <h4>Hurry Up And Get 25% Discount</h4>
                            <p>Donec sollicitudin molestie malesuada.<br/> Lorem ipsum dolor sit amet, <br/>consectetur adipiscing elit.</p>
                            <button class="shop_now">shop now</button>
                            <div class="flash-main">
                                <div class="flash_count">
                                    <h1 class="titel counter">4</h1>
                                    <h5>days</h5>
                                </div>
                                <div class="flash_count">
                                    <h1 class="titel counter">10</h1>
                                    <h5>Hours</h5>
                                </div>
                                <div class="flash_count">
                                    <h1 class="titel counter">45</h1>
                                    <h5>Minutes</h5>
                                </div>
                                <div class="flash_count">
                                    <h1 class="titel counter">36</h1>
                                    <h5>Seconds</h5>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </section>
    </>
  )
}

export default FlashDeals